module.exports = __webpack_public_path__ + "static/img/merchant_feature_7.d3c9c0a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/uupay/images/merchant_feature_7.png
// module id = mqoB
// module chunks = 8